import React from "react";
import { useTranslation } from "react-i18next";
import "../../assets/styles/TypingIndicator.css";

const TypingIndicator = () => {
    // Provide a fallback string in case the translation key is missing
    const { t } = useTranslation(["chatbot"]);
    const thinkingLabel = t("chatbot.thinkingMessage", "Thinking...");

    return (
        <div className="typing-container">
            {/* AI avatar */}
            <div className="typing-avatar">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="10" rx="2" />
                    <circle cx="12" cy="5" r="2" />
                    <line x1="12" y1="7" x2="12" y2="11" />
                </svg>
            </div>

            {/* Animated bubble */}
            <div className="typing-bubble">
                <div className="typing-content">
                    <div className="typing-dots">
                        <div className="typing-dot" style={{ animationDelay: "0ms" }} />
                        <div className="typing-dot" style={{ animationDelay: "200ms" }} />
                        <div className="typing-dot" style={{ animationDelay: "400ms" }} />
                    </div>
                    <span className="typing-text">{thinkingLabel}</span>
                </div>
            </div>
        </div>
    );
};

export default TypingIndicator;